import { IRootState } from '../../../store'
import { IPickupAddressOptionsState } from '../store/options.types'

export const getPickupAddressOptionsSelector = (state: IRootState): IPickupAddressOptionsState =>
  state.options.pickupAddressOptions
